import axios from 'axios'

export const SPEECH_HIT_AUDIT_URL = '/api/rest/cas/audit/changeconfidence'
export const SPEECH_HITS_URL = '/api/rest/cas/contact'

export default {
  async auditPhrase(ccrid, data) {
    try {
      const response = await axios.put(`${SPEECH_HIT_AUDIT_URL}?ccrid=${ccrid}`, data)
      return response.data
    } catch (e) {
      throw new Error(e)
    }
  },
  async getPhoneticPhraseHits(ccrid, { confidence = 0, isRootRecording = false } = {}) {
    try {
      const response = await axios.get(SPEECH_HITS_URL, {
        params: {
          ccrid,
          confidence,
          isRootRecording,
        },
      })
      const { data } = response
      data.hits = data.hits || []
      data.hits.forEach(hit => {
        hit.source = 'phonetics' // i18n key
        return hit
      })
      return data
    } catch (e) {
      throw new Error(e)
    }
  },
}
